import { OnSpotAnswer, OnSpotQuestion } from '@/model/onSpot/OnSpot';
import './question.scss';
import Answer from './Answer';

interface QuestionProps {
    question: OnSpotQuestion;
    handleChange: (question: OnSpotQuestion, answerId: OnSpotAnswer, treeSectionId: string, value?: string) => void;
    treeSectionId: string;
}

export const Question = ({ question, handleChange, treeSectionId }: QuestionProps) => {
    const additionalClasses =
        question.type === 'multipleChoice' || question.type === 'singleChoice' ? 'question-container--chip' : '';
    return (
        <div className={`question-container ${additionalClasses}`}>
            <p className="question">
                <span className="text-bold">{question.question}</span> {question.additionalInfo}
            </p>
            <div className="answers">
                {question.answers.map((answer) => {
                    return (
                        <Answer
                            key={answer.id}
                            question={question}
                            treeSectionId={treeSectionId}
                            answer={answer}
                            handleChange={(answer, value) => {
                                handleChange(question, answer, treeSectionId, value);
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};
export default Question;
